import script from "./cardRetreatInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./cardRetreatInfo.vue?vue&type=script&setup=true&lang=js"

import "./cardRetreatInfo.vue?vue&type=style&index=0&id=d600bcba&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d600bcba"]])

export default __exports__